export default __webpack_public_path__ + "static/depthInfo-71e8d5a96235c36bb11bf98c72b46eae.gif";